<template>
  <div>
    <BModal
      id="modalDoc"
      centered
      title="Документы"
      ok-variant="info"
      ok-title="Да"
      cancel-title="Отмена"
      hide-footer
      responsive
      size="xl"
      no-close-on-backdrop
    >
      <div class="text-right">
        <b-button
          variant="primary"
          @click="openDocAddModal"
        >
          <feather-icon
            icon="PlusIcon"
          />
          Добавить документы
        </b-button>
      </div>
      <BTable
        class="my-2"
        :items="docvalue.results"
        :fields="getFields"
        show-empty
        empty-text="Нет данных"
      >
        <template #cell(file)="props">
          <div class="d-flex flex-wrap">
            <b-button
              v-for="(t, index) in props.item.files"
              :key="index"
              v-b-tooltip.hover.v-primary
              size="sm"
              :title="props.item.file_title"
              variant="outline-primary"
              class="mr-1 mb-1 position-relative"
              @click.stop="downloadImage(t)"
            >
              <b-badge
                variant="danger"
                class="bbg_t"
                @click.stop="deleteFileData(t.id)"
              >
                x
              </b-badge>
              <feather-icon icon="FileIcon" />
              {{ t.file_title }}
            </b-button>
          </div>
        </template>
        <template #cell(actions)="props">
          <BButton
            class="p-50 mr-1"
            variant="warning"
            @click="editDocModal(props.item)"
          >
            <feather-icon
              icon="EditIcon"
            />
          </BButton>
          <BButton
            class="p-50"
            variant="danger"
            @click="$emit('deleteDataDocument', props.item.id)"
          >
            <feather-icon icon="XIcon" />
          </BButton>
        </template>
        <template #cell(tags)="props">
          <div
            v-for="(item, index) in props.item.tags"
            :key="index"
          >
            <b-badge variant="success">
              {{ item.name }} {{ " " }}
            </b-badge>
          </div>
        </template>
      </BTable>
      <BCPagination
        :count="docvalue.count"
        @input="changePag"
      />
    </BModal>

    <addEditModal
      :type="type"
      :additional1="additional1"
      :form-data="formData"
      :edit-doc="editDoc"
      @createDoc="$emit('createDoc')"
      @editDocuments="editDocuments"
      @hideModal="$emit('hideModal')"
    />

    <casesFileModal
      :file-data="fileData"
    />
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BTable,
  VBTooltip,
  BBadge,
} from 'bootstrap-vue'
import addEditModal from '@/components/modalDocDebts/addEditModal.vue'
import casesFileModal from '@/components/casesFileModal/modal.vue'
import BCPagination from '@/components/BCPagination.vue'
import { mapActions } from 'vuex'
import areYouSure from '@/mixins/areYouSure'

export default {
  name: 'TheDocModal',
  components: {
    BModal,
    BButton,
    BTable,
    addEditModal,
    casesFileModal,
    BCPagination,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [areYouSure],
  props: {
    additional1: {
      type: Boolean,
      default: () => false,
    },
    docvalue: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {
      },
    },
    type: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      fields: [
        {
          label: 'Дата создания',
          key: 'created_date',
          sortable: true,
        },
        {
          label: 'Дата документа',
          key: 'date_document',
        },
        {
          label: 'Вид документ',
          key: 'tags',
        },
        {
          label: 'Файлы',
          key: 'file',
        },
        {
          label: 'Полезная информация',
          key: 'title',
        },
        {
          label: 'Комментарий',
          key: 'comment',
        },
        {
          label: 'Действия',
          key: 'actions',
        },
      ],
      editDoc: {},
      fileData: {},
    }
  },
  computed: {
    getFields() {
      if (this.additional1) {
        return this.fields
      }
      const arr = this.fields.filter(item => !item.additional)
      return arr
    },
  },
  methods: {
    ...mapActions('cases', ['DELETE_DEBT_DOCUMENT_FILE_DATA']),

    deleteFileData(id) {
      this.$_showAreYouSureModal()
        .then(e => {
          if (e) {
            this.DELETE_DEBT_DOCUMENT_FILE_DATA(id)
              .then(() => {
                this.$emit('docRefresh')
              })
          }
        })
    },

    changePag(data) {
      this.$emit('docRefresh', data)
    },

    downloadImage(t) {
      this.fileData = t
      this.$nextTick(() => {
        this.$bvModal.show('modalFileCases')
      })
    },

    editDocuments() {
      this.$emit('editDocuments', this.editDoc.id)
      this.$emit('hideModal')
    },

    openDocAddModal() {
      this.editDoc = {}
      this.$emit('hideModal')
      this.$nextTick(() => {
        this.$bvModal.show('addEditDoc')
      })
    },

    editDocModal(item) {
      this.editDoc = item
      this.$nextTick(() => {
        this.$bvModal.show('addEditDoc')
      })
    },
  },
}
</script>

<style>
.file__w {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.bbg_t {
  position: absolute!important;
  right: -8px!important;
  top: -8px!important;
}
</style>
